import React, { FC, useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import parseYoutubeUrl from './parseYoutubeUrl'

const mID = 'youtube-player'

const AUTOPLAY_SAFE_PARAMS = 'autoplay=0&enablejsapi=1'

const YouTubeIFrame: FC<IYouTubeIFrame> = ({ id, url, className, placeholder }) => {
  const [isVideoShowing, setIsVideoShowing] = useState(placeholder ? false : true)
  const iframeRef = useRef<HTMLIFrameElement | null>(null)

  const stopVideo = useCallback(() => {
    const iframeEl = iframeRef.current
    if (!iframeEl) {
      return
    }

    iframeEl.contentWindow?.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'stopVideo',
        args: []
      }),
      '*'
    )
  }, [])

  useEffect(() => {
    if (!isVideoShowing) {
      return
    }

    const timeoutId = window.setTimeout(stopVideo, 0)
    return () => window.clearTimeout(timeoutId)
  }, [isVideoShowing, stopVideo])

  const handleIframeLoad = () => {
    stopVideo()
  }
  return (
    <>
      {!isVideoShowing ?
        <Wrapper onClick={() => {setIsVideoShowing(true)}}>
          <StyledVideoPlaceholder $placeholder={placeholder}>
            Loading...
          </StyledVideoPlaceholder>
        </Wrapper>
        : <div className={classNames(className, mID)}>
          <iframe
            ref={iframeRef}
            className={`${mID}__iframe`}
            allowFullScreen={true}
            allow='accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            title='Meet the artists | Tolia Astakhishvili'
            width='640'
            height='360'
            src={`https://www.youtube.com/embed/${parseYoutubeUrl(url)}?${AUTOPLAY_SAFE_PARAMS}`}
            id={id}
            onLoad={handleIframeLoad}
          />
        </div>
      }
    </>
  )
}

const Wrapper = styled.div<any>`
  width: 100%;
  height: 100%;
`

const StyledVideoPlaceholder = styled.div<any>`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${(props) => props.$placeholder});
`

const YouTubeIFRAME = styled(YouTubeIFrame)`
  .${mID} {
    &__iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }

  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
`

interface IYouTubeIFrame {
  id?: string,
  url: string,
  className?: string,
  placeholder?: string
}

export default YouTubeIFRAME
